import { z } from "zod";

// Mirror API validation rules for contacts while keeping
// local form-specific fields.
const PhoneNumber = z.string().regex(/^\+\d{6,15}$/, "Phone number must be in international format, e.g. +61123456789");

export const emailContactSchema = z.object({
  email: z
    .string()
    .min(1, "Email address is required")
    .check(z.email({ error: "Please enter a valid email address" })),
});

export const smsContactSchema = z.object({
  name: z.string().min(1, "Contact name is required").max(100, "Name must be less than 100 characters"),
  phone_number: PhoneNumber,
});

export type EmailContactFormData = z.infer<typeof emailContactSchema>;
export type SmsContactFormData = z.infer<typeof smsContactSchema>;
